import { Tooltip } from 'react-tooltip';

interface CustomTooltipProps {
  anchorSelect: string;
  place?: 'left' | 'right' | 'top' | 'bottom';
  hasDelay?: boolean;
  children?: React.ReactNode;
}

const CustomTooltip = ({ hasDelay = false, ...props }: CustomTooltipProps) => {
  return <Tooltip {...(hasDelay && { delayShow: 600 })} {...props} />;
};

export default CustomTooltip;
